import { render } from "./AddPatient.vue?vue&type=template&id=2cd0181d&scoped=true&ts=true"
import script from "./AddPatient.vue?vue&type=script&lang=ts"
export * from "./AddPatient.vue?vue&type=script&lang=ts"

import "./AddPatient.vue?vue&type=style&index=0&id=2cd0181d&scoped=true&lang=css"

import exportComponent from "d:\\jenkins-nodes\\Atlanta\\workspace\\atlanta-fe-git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd0181d"]])

export default __exports__